import { extractPropertyAddressFromSubject } from "../../../supabase/functions/_shared/ticketInboundMetadata.ts";
import { PUBLIC_EMAIL_HOSTS } from "@/modules/tickets/TicketMessageAvatar";

/**
 * Hints for linking an unlinked ticket. They are only suggestions shown to
 * the user: a property address or a similar domain never links a ticket.
 */
export const getTicketSuggestionHints = (ticket: {
  subject?: string | null;
  requester_email?: string | null;
}) => {
  const address = extractPropertyAddressFromSubject(ticket.subject ?? "");
  const host =
    ticket.requester_email?.trim().toLowerCase().split("@")[1]?.trim() ?? "";
  const domain =
    host && host.includes(".") && !PUBLIC_EMAIL_HOSTS.has(host) ? host : null;
  const street = address?.split(",")[0]?.trim() ?? "";
  return {
    /** ilike pattern for the property's street line, or null. */
    addressPattern:
      street.length >= 5 ? `%${street.replace(/\s+/g, "%")}%` : null,
    address,
    /** Sender's company domain (public mailbox hosts excluded), or null. */
    domain,
  };
};

/** True when a company website points at the given domain. */
export const websiteMatchesDomain = (
  website: string | null | undefined,
  domain: string,
) => {
  const host = (website ?? "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .split(/[/?#:]/)[0];
  return Boolean(host) && (host === domain || domain.endsWith(`.${host}`));
};
